export const CCP_SEND = '/v2/ccp/send';
export const WIDGET_GET_CONVERSATIONS = '/v2/message/userConversations';
export const MESSAGE_CONVERSATION = '/v2/message/conversation';
export const DELETE_CONVERSATION = '/v2/message/markAsDeleted';
export const CCP_GET_CONFIG = '/v2/ccp/user/getConfig';
export const GIFT_PRICES = '/v2/ccp/gifts/getGiftPricing';
